export interface Account {
  id: number
  givenName: null | string
  middleName: null | string
  suffix: null | string
  familyName: null | string
  homePhone: null | string
  mobilePhone: null | string
  workPhone: null | string
  userName: null | string
  emailAddress: null | string
  street: null | string
  zip: null | string
  city: null | string
  state: null | string
  ssn: null | string
  caseCount: number
  accountCreationStep: number
  contactType: number
}

export enum ContactTypeEnum {
  Email = 1,
  Text = 2,
  EmailAndText = 3
}

export function getInitialContactTypeArrayValue(contactType: number): string[] {
  if (contactType === ContactTypeEnum.Email) {
    return ['Email']
  } else if (contactType === ContactTypeEnum.Text) {
    return ['Text']
  } else if (contactType === ContactTypeEnum.EmailAndText) {
    return ['Email', 'Text']
  } else {
    return ['Email']
  }
}

export function getContactTypeValueFromArray(
  contactTypeArray: string[]
): number {
  if (contactTypeArray.includes('Email') && contactTypeArray.includes('Text')) {
    return ContactTypeEnum.EmailAndText
  } else if (contactTypeArray.includes('Text')) {
    return ContactTypeEnum.Text
  } else {
    return ContactTypeEnum.Email
  }
}

export function getContactTypeDescription(
  contactType: number | null | undefined
): string {
  if (contactType) {
    if (contactType === ContactTypeEnum.Email) {
      return 'Email'
    } else if (contactType === ContactTypeEnum.Text) {
      return 'Text'
    } else if (contactType === ContactTypeEnum.EmailAndText) {
      return 'Email and Text'
    } else {
      return 'Email'
    }
  }
  return ''
}
